import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { isUserDrivenNarrowing, pruneEmptyPredicates } from './agreementFilterActivity';
import { useAgreementsAiSearchStore } from './useAgreementsAiSearchStore';
const EMPTY = [];
const PAGE_LIMIT = 200;
export const useAgreementsAiSearchResults = (param)=>{
    let { businessId, isVendor, enabled = true } = param;
    var _ref, _ref1;
    const { api } = useStoreActions();
    const filter = useAgreementsAiSearchStore((s)=>s.filter);
    const lastQuery = useAgreementsAiSearchStore((s)=>s.lastQuery);
    const filterEdited = useAgreementsAiSearchStore((s)=>s.filterEditedSinceLastSearch);
    const setError = useAgreementsAiSearchStore((s)=>s.setError);
    const isActive = enabled && isUserDrivenNarrowing({
        filter,
        lastQuery,
        filterEditedSinceLastSearch: filterEdited
    });
    const { data, isFetching, isLoading, refresh } = useQueryState({
        queryKey: [
            QueryKeys.AgreementsAiSearchResults,
            filter,
            businessId,
            isVendor
        ],
        queryFn: (param)=>{
            let { signal } = param;
            if (filter == null) throw new Error('agreements AI-search query enabled without a filter');
            return api.relationship.searchSummaries({
                businessId,
                filter: pruneEmptyPredicates(filter),
                isVendor,
                limit: PAGE_LIMIT,
                signal
            });
        },
        enabled: isActive,
        staleTime: 0,
        cacheTime: 0,
        onError: ()=>setError('search_failed'),
        onSuccess: ()=>setError(null)
    });
    const agreements = (_ref = data === null || data === void 0 ? void 0 : data.entries) !== null && _ref !== void 0 ? _ref : EMPTY;
    return {
        agreements,
        isActive,
        isFetching,
        isLoading,
        refresh,
        renderedCount: agreements.length,
        totalMatchCount: (_ref1 = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _ref1 !== void 0 ? _ref1 : 0
    };
};
